import React from "react";
import { FiClock } from "react-icons/fi";

const ScheduleComponent = ({ events }) => {
  return (
    <div className="mx-4 my-2">
      <h1 className="text-lg font-semibold mb-2">Event Schedule</h1>

      {/* Header row */}
      <hr className=" block md:hidden border-gray-400" />
      <div className="hidden md:grid grid-cols-3 md:grid-cols-3 items-center py-2 border-b bg-gray-300 text-sm font-semibold text-left">
        <div className="pl-2">Timing</div>
        {/* <div>Anchor</div> */}
        <div>Event Topic</div>
        <div className="text-right mr-6">Speaker</div>
      </div>

      {/* Data rows */}
      {events?.map((event, idx) => (
        <div
          key={idx}
          className="  hidden md:grid grid-cols-3 items-center py-4 border-b border-gray-400 text-sm"
        >
          {/* Timing */}
          <div className="flex items-center gap-1 pl-2">
            <FiClock size={18} className="text-[#0C8A70]" />
            <span>{event?.times}</span>
          </div>

          {/* Anchor */}
          {/* <div className="flex items-center">{event?.anchorName}</div> */}

          {/* Topic */}
          <div className="flex text-[#0C8A70]  ">{event?.eventTopic}</div>

          {/* Guest + Image (right aligned) */}
          <div className="flex items-center justify-end gap-2   text-right">
            <div className="flex flex-col md:w-[55%]">
              {event.guestDetail?.map((item, gIdx) => (
                <div key={gIdx}>
                  <h4 className="font-semibold">{item?.guestName}</h4>
                  <p>{item?.role}</p>
                </div>
              ))}
            </div>

            {event.image && (
              <div className="w-[60px] h-[60px] border-2  rounded-full overflow-hidden">
                <img
                  src={event.image}
                  alt={event?.name}
                  className="w-full h-full object-cover "
                />
              </div>
            )}
          </div>
        </div>
      ))}

      {events?.map((event, idx) => (
        <div
          key={idx}
          className="block md:hidden  border-b border-gray-400 py-4 text-sm"
        >
          {/* Time + Anchor */}
          <div className="flex items-center gap-1 mx-4 text-black font-medium mb-2">
            <FiClock size={16} className="text-[#0C8A70]" />
            <span>{event?.times}</span>
            {/* <span>•</span>
      <span className="text-[#0C8A70]">{event?.anchorName}</span> */}
          </div>

          {/* Event topic */}
          <div className="text-[#0C8A70] font-semibold leading-snug mt-1  mx-[35px]">
            {event?.eventTopic}
          </div>
          <hr className="mx-5" />
          {/* Guests */}
          <div className="mt-2 mx-[35px] flex flex-col gap-2">
            {event.guestDetail?.map((item, gIdx) => (
              <div key={gIdx} className="flex items-center gap-2">
                <div className="w-[50px] h-[50px] rounded-full border overflow-hidden">
                  <img
                    src={event.image} // Or item.image if individual images
                    alt={item?.guestName}
                    className="w-full h-full object-cover "
                  />
                </div>
                <div>
                  <div className="font-semibold">{item?.guestName}</div>
                  <div className="text-gray-500">{item?.role}</div>
                </div>
              </div>
            ))}
          </div>
        </div>
      ))}
    </div>
  );
};

export default ScheduleComponent;
